import React from "react";
import "./index.scss";
import WidgetHeader from "./../WidgetHeader";

import { valueStrings } from "../../../constants/constantStrings";
import PageLoading from "components/PageLoading/index.js";
import { connect } from "react-redux";
import TextAnimation from "components/TextAnimation/TextAnimation";
class TagItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menuTargetEl: null };
  }

  menuHandler = event => {
    this.setState({ ...this.state, menuTargetEl: event.currentTarget, error: "" });
  };

  onMenuClose = (actionType, widgetID) => {
    this.props.onWidgetAction(actionType, widgetID, "TAG");
  };

  tagValue = (Value, Units) => `${Value} ${Units}`;

  render() {
    const { tagData, isWidgetUpdating, tagsAsObj } = this.props;
    const { TagId, Description, TagName, Units } = tagData;
    const tagDescription = `${TagId} | ${Description}`;
    const Value = tagsAsObj[TagId]?.Value;

    return (
      <div className="cardContainer" ref={node => (this.node = node)}>
        {isWidgetUpdating ? (
          <PageLoading customHeight="100%" />
        ) : (
          <>
            <WidgetHeader
              title={TagName}
              description={tagDescription}
              onWidgetAction={this.onMenuClose}
              WidgetID={tagData.Id}
              tagData={tagData}
              customClass="tag-description"
            />
            <div className="tag-error">{this.state.error}</div>
            <div className="valContainer">
              <div className="tagValue">
                <TextAnimation text={Value} position="" />
              </div>
              <div className="tagUnit text-center">{Units}</div>
              <div className="descriptionText text-center marginBtm20">{valueStrings.currentVal}</div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ tags }) => {
  return { tagsAsObj: tags.tagsAsObj };
};

export default connect(mapStateToProps)(TagItem);
